import React from 'react';
import { REAUTHORISE_TARGET_DOC_LINK } from '../../constants';
import { HdDocLink, HdIcon } from '../../../../components';

export function ObjectExplorerUnselectedTarget() {
  return (
    <div className='no-item-box'>
      <div className='no-item-box-icon-container'>
        <HdIcon name='table' className='no-item-box-icon'/>
      </div>

      <p className='no-item-box-title'>
        Select the Target Object 👆🏻
      </p>

      <div className='no-item-box-desc'>
        <HdDocLink
          dataId='target-object-explorer-reauth'
          docLink={REAUTHORISE_TARGET_DOC_LINK}
          section='create_activaton'
        />
        {' '}
        to learn more about the supported Objects.
      </div>
    </div>
  );
}
